import { Col, Container, Row } from "react-bootstrap";

import { mdiArrowRightBoldCircle, mdiHeart } from '@mdi/js';
import Icon from '@mdi/react';

import { Spacer, SpacerBig } from "./Dividers";
import blorb2 from "../assets/img/BlorbSprite_2.png";

export const EarlyAccess = () => {
    return (
        <section id="earlyaccess" className="earlyaccess section neb-blue">
            <Container>
                <SpacerBig />
                <h1>Early Access</h1>
                <Row>
                    <Col sm={12} md={6}>
                        <Spacer />
                        <h2>You can help!</h2>
                        <p>
                            Elysian Eclipse is completely funded by its community and
                            independent of any big investors or shareholders.
                            Our goal isn't to make money, but a great game!
                            <br />
                            <br />
                            All of our aquatic tier or higher supporters can test updates of the game
                            before they release to the public.
                            You too can help us fund the development of EE
                            and get the newest releases or just a place in the credits.
                            <br />
                            <br />
                            Thank you! Without you this wouldn't be possible!
                            <span>
                                <Icon path={mdiHeart} size={1.5} color="plum" style={{ marginLeft: 10 }} />
                            </span>
                        </p>
                        <a
                            href="https://ko-fi.com/wauzmons/tiers"
                            target="_blank"
                            rel="noreferrer">
                            <button className="action-button action-button-min">
                                Support on Ko-fi (Recommended Option)
                                <Icon path={mdiArrowRightBoldCircle} size={1} color="white" />
                            </button>
                        </a>
                        <a
                            href="https://www.patreon.com/wauzmons"
                            target="_blank"
                            rel="noreferrer">
                            <button className="action-button action-button-min">
                                or Patreon (Legacy Option)
                                <Icon path={mdiArrowRightBoldCircle} size={1} color="white" />
                            </button>
                        </a>
                        <Spacer />
                        <h2>Free Alpha Version</h2>
                        <p>
                            To celebrate the first birthday of the project,
                            EE is now available for free.
                            If you are having fun with the alpha,
                            please consider supporting us on Ko-fi,
                            so we can continue to create free updates!
                        </p>
                        <a
                            href="https://dl.elysian-eclipse.com/EE_Alpha_0.6.3_1fd302c2-3468-43a4-a922-b84dda963ff3.zip"
                            target="_blank"
                            rel="noreferrer">
                            <button className="action-button action-button-min">
                                Download the Free Alpha
                                <Icon path={mdiArrowRightBoldCircle} size={1} color="white" />
                            </button>
                        </a>
                        <Spacer />
                        <h2>System Requirements</h2>
                        <p>
                            <b>OS: </b>Windows 10 / 11<br />
                            <b>Processor: </b>INTEL CORE I5-8400 or AMD RYZEN 3 3300X<br />
                            <b>Memory: </b>8 GB RAM<br />
                            <b>Graphics: </b>NVIDIA GEFORCE GTX 1060 3 GB or AMD RADEON RX 580 4 GB<br />
                            <b>DirectX: </b>Version 11<br />
                            <b>Storage: </b>5 GB available space<br />
                            <b>Notes: </b>Additional disk space required to store player-made creations.
                        </p>
                    </Col>
                    <Col sm={12} md={6}>
                        <img src={blorb2} alt="Blorb" />
                    </Col>
                </Row>
                <Spacer />
            </Container>
        </section>
    );
}